export default "__VITE_ASSET__TEl8wH_Q__"